<template>
  <div class="image-only" :style="{backgroundColor: eleConfig.backgroundColor || '#FFFFFF'}">
    <div class="image-inner">
      <h2 class="title" :style="titleStyle">{{ $dt(eleConfig, 'title') }}</h2>
      <div v-if="eleConfig.content" class="content" :style="contentStyle">{{ $dt(eleConfig, 'content') }}</div>
      <div class="img-box">
        <a-image v-if="eleConfig.otherConfig.imgPreviewFlag" :width="imgWidth" :src="imgSrc" />
        <img v-else :src="imgSrc" :style="{width: imgWidth}" />
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';
import DolImagePreview from '@/components/dolphin-ant-design/display/dol-image-preview.vue';

export default {
  name: "imageOnly",
  components: { DolImagePreview },
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
    imgWidth() {
      return this.getNumber(this.eleConfig.otherConfig.imgWidth, 100) + '%';
    },
    titleStyle() {
      const style = {};
      style.color = this.eleConfig.otherConfig.titleColor || '#333333';
      if (this.eleConfig.otherConfig.titleCenterFlag) style.textAlign = 'center';
      return style;
    },
    contentStyle() {
      const style = {};
      style.color = this.eleConfig.otherConfig.contentColor || '#333333';
      if (this.eleConfig.otherConfig.contentCenterFlag) style.textAlign = 'center';
      return style;
    },
  }
}
</script>

<style scoped lang="scss">
.image-only {
  width: 100%;
  padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .image-inner {
    width: 1280px;
    margin: 0 auto;

    .title {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 32px;
      line-height: 45px;
    }

    .content {
      font-size: 18px;
      white-space: pre-wrap;
      line-height: 25px;
      margin-bottom: 64px;
    }

    .img-box {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
